import { Button } from '@askable/ui/core/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@askable/ui/core/dialog';
import { toast } from '@askable/ui/core/sonner';
import _ from 'lodash';
import momentTimezone from 'moment-timezone';
import { Component } from 'react';

import { LoadingOverlay, CountDownTimer } from 'components/common';
import { FindParticipantSessionById } from 'data/queries/bookingSubmission/findParticipantSessionById.query';
import { urqlFetch } from 'lib/urqlFetch';
import { getCombinedErrorMessage } from 'utils/error_utils';

import ConfirmationMessageInvitationDialog from './confirmationMessage';
import InvitationDialogContentContainer from './contentContainer';

class ReInviteParticipant extends Component<{
  loading: boolean;
  showConfirmationMessage: boolean;
}> {
  timer: any;

  constructor(props: any) {
    super(props);

    this.state = {
      coolDownTime: 0,
      isRunning: false,
    };

    this.onCloseModal = this.onCloseModal.bind(this);
    this.renderCooldownMessage = this.renderCooldownMessage.bind(this);
  }

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'open' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    if (this.props.open) {
      void this.onCheckCountDownTimer(this.props);
    }
  }

  // oxlint-disable-next-line react/no-unsafe -- This must run before each render with new props. componentDidUpdate runs after the render and also on state changes.
  UNSAFE_componentWillReceiveProps(newProps: any) {
    if (newProps.open) {
      void this.onCheckCountDownTimer(newProps);
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'coolDownTime' does not exist on type 'Re... Remove this comment to see the full error message
    if (this.state.coolDownTime <= 0 && this.timer) clearInterval(this.timer);
  }

  async onCheckCountDownTimer(props: any) {
    // Check whether it needs to render a countDownTimer
    // If it does, it should get the last time a participant got invited
    this.setState({ isRunning: true });
    let lastInvitedTime;
    try {
      lastInvitedTime = await this.getLastInvitedTime(_.get(props, 'singleSession.participant.invitedSession'));
    } catch {
      // Keep isRunning true so the resend button stays disabled and the 15-min cooldown can't be bypassed.
      return null;
    }
    if (!lastInvitedTime) {
      this.setState({ isRunning: false });
      return null;
    }

    // Get the difference in seconds
    const difference = momentTimezone().diff(lastInvitedTime) / 1000;

    // Check if the difference is less than 15 minutes
    if (difference <= 900) {
      this.setState(
        {
          coolDownTime: 900 - difference,
        },
        () => {
          this.timer = setInterval(() => {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'coolDownTime' does not exist on type 'Re... Remove this comment to see the full error message
            const newCount = this.state.coolDownTime - 1;
            this.setState({ coolDownTime: newCount >= 0 ? newCount : 0 });
          }, 1000);
        },
      );
    }
    this.setState({ isRunning: false });
  }

  onCloseModal() {
    if (this.timer) clearInterval(this.timer);
    this.setState({ coolDownTime: 0 });
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onCloseInvitationDialog' does not exist ... Remove this comment to see the full error message
    this.props.onCloseInvitationDialog();
  }

  async getLastInvitedTime(invitedSession: any) {
    const { data, error } = await urqlFetch(FindParticipantSessionById, {
      _id: invitedSession._id,
    });
    if (error) {
      toast.error(getCombinedErrorMessage(error, 'Error checking re-invite cooldown'));
      throw error;
    }
    const history = data?.findParticipantSessionById?.history;
    return (
      history?.session_invitation_notification_followup ||
      history?.session_invitation_notification ||
      history?.session_quant_invitation_notification
    );
  }

  renderCooldownMessage() {
    // The last invitation can either be the first time the user had been invited or the last time he has been re-invited
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'coolDownTime' does not exist on type 'Re... Remove this comment to see the full error message
    if (this.state.coolDownTime <= 0) return null;
    return (
      <div className="cooldownTime">
        <p>
          {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'coolDownTime' does not exist on type 'Re... Remove this comment to see the full error message */}
          <CountDownTimer time={this.state.coolDownTime} />
        </p>
      </div>
    );
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'singleSession' does not exist on type 'R... Remove this comment to see the full error message
    const { participant, session, isAvailableForSession } = this.props.singleSession;
    const hasBeenInvited = _.has(participant, 'invitedSession');
    return (
      <Dialog
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'open' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        open={this.props.open}
        modal={false}
        onOpenChange={open => !open && this.onCloseModal()}
      >
        <DialogContent className="inviteParticipantsContainer max300" aria-describedby={undefined}>
          <DialogHeader>
            <DialogTitle className="sr-only">Resend invitation</DialogTitle>
          </DialogHeader>
          <div className="dialogBody text-pretty text-sm">
            {this.props.loading && <LoadingOverlay style={{ opacity: 0.8 }} />}
            {this.props.showConfirmationMessage ? (
              <ConfirmationMessageInvitationDialog
                {...this.props}
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ onFinishCustom: () => void; }' is not assi... Remove this comment to see the full error message
                onFinishCustom={this.onCloseModal}
              />
            ) : (
              <>
                <p>
                  Resend invitation to {_.get(participant, 'user.meta.identity.firstname')}{' '}
                  {_.get(participant, 'user.meta.identity.lastname')}?
                </p>
                <InvitationDialogContentContainer
                  participant={participant}
                  session={session}
                  isAvailableForSession={isAvailableForSession}
                  {...this.props}
                />
                <div className="buttonsContainer">
                  <Button
                    variant="default"
                    className="mt-5 max-w-[150px]"
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onConfirm' does not exist on type 'Reado... Remove this comment to see the full error message
                    onClick={this.props.onConfirm}
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'coolDownTime' does not exist on type 'Re... Remove this comment to see the full error message
                    disabled={(this.state.coolDownTime > 0 && this.state.isRunning === false) || this.state.isRunning}
                  >
                    Resend Invite
                  </Button>
                  {/* @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1. */}
                  {hasBeenInvited && this.renderCooldownMessage(participant.invitedSession)}
                </div>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ReInviteParticipant;
